import { render, staticRenderFns } from "./NoteInfo.vue?vue&type=template&id=8d95543e&scoped=true&lang=pug"
import script from "./NoteInfo.vue?vue&type=script&lang=js"
export * from "./NoteInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d95543e",
  null
  
)

export default component.exports